import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { JobService } from 'src/app/core/services/job.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';

declare var $: any;

@Component({
  selector: 'app-job-candidates-compare',
  templateUrl: './job-candidates-compare.component.html',
  styleUrls: ['./job-candidates-compare.component.css']
})
export class JobCandidatesCompareComponent implements OnInit {

  @Input() jobId: any;
  @Input() candidateIds: any;

  isSuperUserOr4dot5Admin = false;
  isJobMatchPanelOpen = true;
  isEducationPanelOpen = true;
  isExperiencePanelOpen = true;
  isTechnicalSkillsPanelOpen = true;
  isOperationalSkillsPanelOpen = true;
  isSoftSkillsPanelOpen = true;
  isOtherSkillsPanelOpen = true;
  isCertificationsPanelOpen = true;
  isCompensationPanelOpen = true;
  isSalaryPanelOpen = true;
  isSponsorshipsPanelOpen = true;
  isRelocationPanelOpen = true;
  isAdditionalInformationPanelOpen = true;
  togglePanelsLabel = 'Collapse All';
  isAllPanelsOpen = true;

  comparisonData: any = [];
  workflowSteps: any;
  jobDetails: any;
  panelClasses = ['education-assets', 'experience-assets', 'tech-assets', 'operational-assets', 'soft-assets', 'certification-assets', 'other-assets', 'compensation-assets', 'salary-assets', 'sponsorship-assets', 'relocation-assets'];
  panelBootStrapColumnWidthClass = 'col-xs-3';
  companyId: any;
  loadingFlag = true;

  constructor(
    private jobMatchActionsService: JobMatchActionsService,
    private authService: AuthService,
    private jobService: JobService,
    private userRoleService: UserRoleService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    $('.modal').css('overflow-y', 'scroll');
    this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    this.isJobMatchPanelOpen = true;
    this.isEducationPanelOpen = true;
    this.isExperiencePanelOpen = true;
    this.isTechnicalSkillsPanelOpen = true;
    this.isOperationalSkillsPanelOpen = true;
    this.isSoftSkillsPanelOpen = true;
    this.isOtherSkillsPanelOpen = true;
    this.isCertificationsPanelOpen = true;
    this.isCompensationPanelOpen = true;
    this.isSalaryPanelOpen = true;
    this.isSponsorshipsPanelOpen = true;
    this.isRelocationPanelOpen = true;
    this.isAdditionalInformationPanelOpen = true;
    this.togglePanelsLabel = 'Collapse All';
    this.isAllPanelsOpen = true;
    this.comparisonData = [];
    this.panelBootStrapColumnWidthClass = 'col-xs-3';
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.loadingFlag = true;

    this.panelBootStrapColumnWidthClass = this.candidateIds.split(',').length == '2' ? 'col-xs-4' : 'col-xs-3';
    this.multipleCandidatesSingleJobComparison();
  }

  togglePanels() {
    this.isAllPanelsOpen = !this.isAllPanelsOpen;
    this.togglePanelsLabel = this.isAllPanelsOpen ? 'Collapse All' : 'Expand All';

    this.isJobMatchPanelOpen = this.isAllPanelsOpen;
    this.isEducationPanelOpen = this.isAllPanelsOpen;
    this.isExperiencePanelOpen = this.isAllPanelsOpen;
    this.isTechnicalSkillsPanelOpen = this.isAllPanelsOpen;
    this.isOperationalSkillsPanelOpen = this.isAllPanelsOpen;
    this.isSoftSkillsPanelOpen = this.isAllPanelsOpen;
    this.isOtherSkillsPanelOpen = this.isAllPanelsOpen;
    this.isCertificationsPanelOpen = this.isAllPanelsOpen;
    this.isCompensationPanelOpen = this.isAllPanelsOpen;
    this.isSalaryPanelOpen = this.isAllPanelsOpen;
    this.isSponsorshipsPanelOpen = this.isAllPanelsOpen;
    this.isRelocationPanelOpen = this.isAllPanelsOpen;
    this.isAdditionalInformationPanelOpen = this.isAllPanelsOpen;

    this.workflowSteps.forEach(step => {
      step.isOpen = this.isAllPanelsOpen;
    });
  }

  multipleCandidatesSingleJobComparison() {
    this.loadingFlag = true;
    this.jobService.multipleCandidatesSingleJobComparison(this.jobId, this.candidateIds, this.companyId, (data) => {
      this.comparisonData = data.multipleCandidateSingleJobComparisonDetails;
      this.workflowSteps = this._getMassagedWorkflowSteps(data.workFlowSteps);
      this._massageComparisonData();
      this.loadingFlag = false;
      this._setHeightsOfPanels();
      this.initializeSliders();
    }, (error) => {
      this.loadingFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getMassagedWorkflowSteps(workflowStepsData) {
    const workflowSteps = [];
    for (const stepKey in workflowStepsData) {
      if (workflowStepsData.hasOwnProperty(stepKey)) {
        workflowSteps.push({ step: workflowStepsData[stepKey], isOpen: true });
      }
    }
    return workflowSteps;
  }

  private _massageComparisonData() {
    _.forEach(this.comparisonData, (comparison, key) => {
      _.forEach(comparison.educationComparisons, (experience, expKey) => {
        if (experience.candidateInstituteName === null || experience.candidateInstituteName === '') {
          experience.candidateInstituteName = "'Unknown'";
        }
      });
      comparison.educationComparisonsGrouped = [];
      if (comparison.educationComparisons) {
        const groupedDegrees = this.groupBy(comparison.educationComparisons, 'jobDegreeName');
        for (const degree in groupedDegrees) {
          if (groupedDegrees.hasOwnProperty(degree)) {
            const institutes = groupedDegrees[degree];
            let institutesText = '';
            institutes.forEach((institution, instKey) => {
              institutesText = `<span> ${institutesText} ${institution.candidateDegreeName} at ${institution.candidateInstituteName}</span><br>`;
            });
            const institute = groupedDegrees[degree][0];
            institute.text = institutesText;
            comparison.educationComparisonsGrouped.push(institute);
          }
        }
      }

      if (comparison.latestEducationDto) {
        if (comparison.latestEducationDto.candidateInstituteName === null || comparison.latestEducationDto.candidateInstituteName === '') {
          comparison.latestEducationDto.candidateInstituteName = "'Unknown'";
        }
      }

      _.forEach(comparison.experienceComparisons, (experience, expKey) => {
        if (experience.company === null || experience.company === '') {
          experience.company = "'Unknown'";
        }
      });

      comparison.jobMatchScore = Math.floor(parseFloat(comparison.jobMatchScore));
      if (comparison.workflowStepsComparisons) {
        if (comparison.workflowStepsComparisons.techAssessmentComparisons && comparison.workflowStepsComparisons.techAssessmentComparisons.score) {
          comparison.workflowStepsComparisons.techAssessmentComparisons.score = Math.floor(parseFloat(comparison.workflowStepsComparisons.techAssessmentComparisons.score));
        }
        if (comparison.workflowStepsComparisons.valueAssessmentComparisons && comparison.workflowStepsComparisons.valueAssessmentComparisons.score) {
          comparison.workflowStepsComparisons.valueAssessmentComparisons.score = Math.floor(parseFloat(comparison.workflowStepsComparisons.valueAssessmentComparisons.score));
        }
      }
      comparison.technicalSkillCounts = { matched: 0, unMatched: 0, additional: 0, almost: 0 };
      comparison.operationalSkillCounts = { matched: 0, unMatched: 0, additional: 0, almost: 0 };
      comparison.softSkillCounts = { matched: 0, unMatched: 0, additional: 0, almost: 0 };
      comparison.otherSkillCounts = { additional: 0 };

      _.forEach(comparison.technicalSkillComparisons, (skill, expKey) => {
        if (skill.status === 'MATCH') {
          comparison.technicalSkillCounts.matched++;
        } else if (skill.status === 'UN_MATCH') {
          comparison.technicalSkillCounts.unMatched++;
        } else if (skill.status === 'ADDITIONAL') {
          comparison.technicalSkillCounts.additional++;
        } else if (skill.status === 'ALMOST') {
          comparison.technicalSkillCounts.almost++;
        }
      });

      _.forEach(comparison.operationalSkillComparisons, (skill, expKey) => {
        if (skill.status === 'MATCH') {
          comparison.operationalSkillCounts.matched++;
        } else if (skill.status === 'UN_MATCH') {
          comparison.operationalSkillCounts.unMatched++;
        } else if (skill.status === 'ADDITIONAL') {
          comparison.operationalSkillCounts.additional++;
        } else if (skill.status === 'ALMOST') {
          comparison.operationalSkillCounts.almost++;
        }
      });

      _.forEach(comparison.softSkillComparisons, (skill, expKey) => {
        if (skill.status === 'MATCH') {
          comparison.softSkillCounts.matched++;
        } else if (skill.status === 'UN_MATCH') {
          comparison.softSkillCounts.unMatched++;
        } else if (skill.status === 'ADDITIONAL') {
          comparison.softSkillCounts.additional++;
        } else if (skill.status === 'ALMOST') {
          comparison.softSkillCounts.almost++;
        }
      });

      _.forEach(comparison.otherComparisons, (skill, expKey) => {
        if (skill.status === 'ADDITIONAL') {
          comparison.otherSkillCounts.additional++;
        }
      });
    });
    this.jobDetails = _.cloneDeep(this.comparisonData[0]);
  }

  groupBy(objectArray, property) {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  private _setHeightsOfPanels() {
    setTimeout(() => {
      _.forEach(this.panelClasses, (val, key) => {
        const panelsArray = $('.' + val);
        const lengths = panelsArray.map((k, panel) => {
          return $(panel).children('li').length;
        }).get();
        const maxLength = Math.max.apply(null, lengths);
        for (let i = 0; i < maxLength; i++) {
          let maxHeight = 0;
          _.forEach(panelsArray, (v, k) => {
            const liItem = $(v).children('li')[i];
            if (!_.isUndefined(liItem) && $(liItem).height() > maxHeight) {
              maxHeight = $(liItem).height();
            }
          });
          _.forEach(panelsArray, (v, k) => {
            const liItem = $(v).children('li')[i];
            if (!_.isUndefined(liItem)) {
              $(liItem).height(maxHeight);
              $(liItem).css('margin', '0px -18px 3px -18px');
              $(liItem).css('padding-left', '40px');
              $(liItem).css('padding-right', '4px');
              if (i % 2 == 0) {
                $(liItem).css('background', '#efefef');
              }
            }
          });
        }

        const heights = panelsArray.map((k, panel) => {
          return $(panel).height();
        }).get();
        const maxHeight = Math.max.apply(null, heights);
        $('.' + val).height(maxHeight);
      });
    }, 200);
  }

  isComparisonEmpty(comparison) {
    return _.isEqual(comparison, {});
  }

  getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId) {
    this.jobMatchActionsService.getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId, 'job-candidates-compare');
  }

  viewFeedback(feedbackType, label, candidateId, jobMatchId) {
    const feedbackDetails = {
      candidateId,
      jobId: this.jobId,
      jobMatchId,
      feedbackType,
      label,
      context: 'jobCandidatesCompare'
    };
    this.jobMatchActionsService.openFeedbackModal(feedbackDetails);
  }

  initializeSliders() {
    setTimeout(() => {
      $("div[class='overall-qn-slider']").each((i, obj) => {
        const jobMatchId = obj.id.split('__')[1].split('_')[0];
        const questionId = obj.id.split('__')[1].split('_')[1];
        const labelId = 'overall-qn-rating__' + jobMatchId + '_' + questionId;
        $(obj).noUiSlider({
          range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
          slide: () => {
            const val = $(obj).val();
            $('#' + labelId).text(Math.round(val));
          },
          set: () => {
            const val = $(obj).val();
            $('#' + labelId).text(Math.round(val));
          }
        });
        const candidate = this.comparisonData.find(c => c.jobMatchId === jobMatchId);
        const feedback = candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks ? candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks[questionId] : { rating: 0 };
        $(obj).val(feedback.rating, true);
      });

      $("div[class='overall-qn-slider_ps']").each((i, obj) => {
        const jobMatchId = obj.id.split('__')[1].split('_')[0];
        const questionId = obj.id.split('__')[1].split('_')[1];
        const labelId = 'overall-qn-rating__' + jobMatchId + '_' + questionId + '_ps';
        $(obj).noUiSlider({
          range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
          slide: () => {
            const val = $(obj).val();
            $('#' + labelId).text(Math.round(val));
          },
          set: () => {
            const val = $(obj).val();
            $('#' + labelId).text(Math.round(val));
          }
        });
        const candidate = this.comparisonData.find(c => c.jobMatchId === jobMatchId);
        const feedback = candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks ? candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks[questionId] : { rating: 0 };
        $(obj).val(feedback.rating, true);
      });

      $("div[class='overall-qn-slider_in']").each((i, obj) => {
        const jobMatchId = obj.id.split('__')[1].split('_')[0];
        const questionId = obj.id.split('__')[1].split('_')[1];
        const labelId = 'overall-qn-rating__' + jobMatchId + '_' + questionId + '_in';
        $(obj).noUiSlider({
          range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
          slide: () => {
            const val = $(obj).val();
            $('#' + labelId).text(Math.round(val));
          },
          set: () => {
            const val = $(obj).val();
            $('#' + labelId).text(Math.round(val));
          }
        });
        const candidate = this.comparisonData.find(c => c.jobMatchId === jobMatchId);
        const feedback = candidate.workflowStepsComparisons.interviewComparisons.feedbacks ? candidate.workflowStepsComparisons.interviewComparisons.feedbacks[questionId] : { rating: 0 };
        $(obj).val(feedback.rating, true);
      });
    }, 200);
  }
}
